import { Avatar, cn } from "@heroui/react";
import { useMemo } from "react";

const CUSTOM_COLORS = {
  secondary: "bg-secondary/20 text-secondary-foreground",
  teal:   "bg-teal/10 text-teal-foreground",
};

const HEROUI_COLORS = ["accent", "success", "warning", "danger", "primary", "default"];

const IconAvatar = ({ icon, color, size = "md", className, iconClassName, strokeWidth = 1.5, ...props }) => {
  const Icon = icon;

  const isHeroUI = HEROUI_COLORS.includes(color);
  const customClass = !isHeroUI ? CUSTOM_COLORS[color] : null;

  return (
    <Avatar
      size={size}
      color={isHeroUI ? color : undefined}
      variant="soft"
      className={cn("rounded-lg", customClass, className)}
      {...props}
    >
      <Avatar.Fallback className={customClass}>
        <Icon className={iconClassName} strokeWidth = {strokeWidth}/>
      </Avatar.Fallback>
    </Avatar>
  );
};

export default IconAvatar;